import { render, staticRenderFns } from "./UMultilineMultilanguageTextInput.vue?vue&type=template&id=005f7c54&scoped=true"
import script from "./UMultilineMultilanguageTextInput.vue?vue&type=script&lang=js"
export * from "./UMultilineMultilanguageTextInput.vue?vue&type=script&lang=js"
import style0 from "./UMultilineMultilanguageTextInput.vue?vue&type=style&index=0&id=005f7c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f7c54",
  null
  
)

export default component.exports